<template>
    <div class="upload">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
            <el-form-item label="模型名称:" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入模型名称,不超过20个字符" maxlength="20" class="name"></el-input>
            </el-form-item>
            <el-form-item label="是否公开:" prop="isPublic">
                <el-switch
                    v-model="ruleForm.isPublic"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>
            </el-form-item>
            <div class="model_scale">
                <el-form-item label="模型长度(米):" prop="modelLong">
                    <el-input type="number" v-model="ruleForm.modelLong"></el-input>
                </el-form-item>
                <el-form-item label="模型宽度(米):" prop="modelWide">
                    <el-input  type="number" v-model="ruleForm.modelWide"></el-input>
                </el-form-item>
                <el-form-item label="模型高度(米):" prop="modelHeight">
                    <el-input  type="number" v-model="ruleForm.modelHeight"></el-input>
                </el-form-item>
            </div>
            <div class="model_file">
                <el-form-item label="模型文件:" prop="fileUrl">
                    <el-upload :action="getModelAction()" :data="{ type: 'model'}" :limit="1" :on-change="handleChangeFile"
                               :on-success="handleSuccessFile" :on-error="handleErrorFile" :headers="uploadHeaders"
                               :on-exceed="handleExceedFile" ref="upload1"
                               :file-list="ruleForm.file">
                        <el-button v-if="!ruleForm.file" >点击上传</el-button>
                        <el-button v-else class="finishBtn">重新上传</el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="model_tag">
                <el-form-item label="所属标签:" prop="tag" style="width: 100%;">
                    <el-select v-model="ruleForm.tag" multiple v-maxlength="20" filterable allow-create default-first-option
                        placeholder="请选择标签或自定义输入标签">
                        <el-option
                            v-for="item in categories"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="model_color">
                <el-form-item label="颜色贴图:">
                    <el-upload :action="getModelAction()" :limit="1" :data="{ type: 'MImage'}" :on-change="handleChangeColor"
                            :on-success="handleSuccessColor" :on-error="handleErrorFile" ref="upload2" :headers="uploadHeaders"
                            :on-exceed="handleExceedFile" :file-list="ruleForm.color">
                            <el-button v-if="!ruleForm.color" >点击上传</el-button>
                            <el-button v-else class="finishBtn">重新上传</el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="model_mental">
                <el-form-item label="金属度贴图:">
                    <el-upload  :action="getModelAction()" :limit="1" :on-change="handleChangeMental" :data="{ type: 'MImage'}"
                                :on-success="handleSuccessMental" :on-error="handleErrorFile" ref="upload3" :headers="uploadHeaders"
                                :on-exceed="handleExceedFile" :file-list="ruleForm.mental">
                                <el-button v-if="!ruleForm.mental" >点击上传</el-button>
                                <el-button v-else class="finishBtn">重新上传</el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="model_ao">
                <el-form-item label="AO贴图:">
                    <el-upload :action="getModelAction()" :limit="1" :on-change="handleChangeAo" :data="{ type: 'MImage'}"
                               :on-success="handleSuccessAo" :on-error="handleErrorFile" ref="upload4" :headers="uploadHeaders"
                               :on-exceed="handleExceedFile" :file-list="ruleForm.ao">
                               <el-button v-if="!ruleForm.ao" >点击上传</el-button>
                               <el-button v-else class="finishBtn">重新上传</el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="model_normal">
                <el-form-item label="法线贴图:">
                    <el-upload :action="getModelAction()" :limit="1" :on-change="handleChangeNormal" :data="{ type: 'MImage'}"
                               :on-success="handleSuccessNormal" :on-error="handleErrorFile" ref="upload5" :headers="uploadHeaders"
                               :on-exceed="handleExceedFile" :file-list="ruleForm.normal">
                               <el-button v-if="!ruleForm.normal" >点击上传</el-button>
                               <el-button v-else class="finishBtn">重新上传</el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="model_shrink">
                <el-form-item label="缩略图:" prop="thumbnailUrl">
                    <el-upload :action="getAction()" :limit="1" :on-change="handleChangeShrink" :data="{ type: 'MImage'}"
                               :on-success="handleSuccessShrink" :on-error="handleErrorFile" ref="upload" :headers="uploadHeaders"
                               :on-exceed="handleExceedFile" :file-list="ruleForm.thumbnail">
                               <el-button v-if="!ruleForm.thumbnail" >点击上传</el-button>
                               <el-button v-else class="finishBtn">重新上传</el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="model_text">
                <el-form-item label="模型描述:" prop="text">
                    <el-input type="textarea" v-model="ruleForm.text" :rows="2" maxlength="200" show-word-limit></el-input>
                </el-form-item>
            </div>
            <!-- <div class="model_company">
                <el-form-item label="所属公司:" prop="company">
                    <el-input v-model="ruleForm.company"></el-input>
                </el-form-item>
            </div>
            <div class="model_company_description">
                <el-form-item label="公司描述:" prop="description">
                    <el-input type="textarea" v-model="ruleForm.description" :rows="2"></el-input>
                </el-form-item>
            </div> -->
        </el-form>
        <div class="uploadBtn">
            <div class="uploadBtn_submit">
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </div>
            <div class="uploadBtn_cancel">
                <el-button @click="resetForm('ruleForm')">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { baseUrl } from '../../../util/constant';
import { fileUpload, uploadUserModel, addUserModel, getAllTag, editUserModel, getModelByIdNoView } from '../../../util/index'
import FormData from 'form-data'
export default {
    name: 'UserEditModel',
    data(){
        return{
            tagValueArray:[
                {
                    value: '标签1',
                    label: '标签1'
                },
                {
                    value: '标签2',
                    label: '标签2'
                },
                {
                    value: '标签3',
                    label: '标签3'
                },
                {
                    value: '标签4',
                    label: '标签4'
                },
                {
                    value: '标签5',
                    label: '标签5'
                },
            ],
            fileListInfo:{
                account: window.localStorage.getItem('userName'),
                chartlet:{
                    name:'',
                    path:'',
                    localPath:'',
                    state:false
                },
                clientUserId: window.localStorage.getItem('userId'),
                color:{
                    name:'',
                    path:'',
                    localPath: '',
                    state:false
                },
                mentallicity:{
                    name:'',
                    path:'',
                    localPath:'',
                    state:false
                },
                modelFile:{
                    name:'',
                    path:'',
                    localPath:'',
                    state:false
                },
                modelDimension:'',
                modelFormat:'',
                modelSize:'',
                modelName: '',
                normal:{
                    name:'',
                    path:'',
                    localPath:'',
                    state:false
                },
                note:'',
                shrinkageFormat:'',
                shrinkageSize:'',
                shrinkageName: '',
                thumbnail:{
                    name:'',
                    path:'',
                    localPath:'',
                    state:false
                },
                labelManageId:'',
                company: '',
                description: ''
            },
            ruleForm: {
                name: '',
                isPublic: false,
                modelLong: '',
                modelWide: '',
                modelHeight: '',
                size: '',
                dimension: '',
                file:[],
                fileFormat:'',
                fileUrl:'',
                modelHash:'',
                color:[],
                colorUrl:'',
                colorMapHash:'',
                mental:[],
                mentalUrl:'',
                metallicMapHash:'',
                ao:[],
                aoUrl:'',
                aoMapHash: '',
                normal:[],
                normalUrl:'',
                normalMapHash: '',
                shrink:[],
                shrinkUrl:'',
                thumbnail: [],
                thumbnailUrl: '',
                thumbnailHash: '',
                shrinkFormat:'',
                shrinkSize:'',
                shrinkName:'',
                tag:'',
                text:'',
                company:'',
                description:'',
                id: '',
                updatedAt: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入模型名称', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                isPublic: [
                    { required: true, message: '请选择是否为通用模型', trigger: 'change' }
                ],
                modelLong: [
                    { required: true, message: '请输入模型长度', trigger: 'blur' }
                ],
                modelWide: [
                    { required: true, message: '请输入模型宽度', trigger: 'blur' }
                ],
                modelHeight: [
                    { required: true, message: '请输入模型高度', trigger: 'blur' }
                ],
                fileUrl: [
                    { required: true, message: '请上传模型文件', trigger: 'submit' }
                ],
                thumbnailUrl: [
                    { required: true, message: '请上传模型缩略图', trigger: 'submit' }
                ]
            },
            labelArray:[],
            categories: [],
        }
    },
    components: {
        
    },
    computed:{
        uploadHeaders (){
            return {
                Authorization: window.localStorage.getItem('userToken')
            }
        }
    },
    mounted(){
        this.initData()
        this.getAllTags()
    },
    methods:{
        initData(){
            let id = this.$route.query.id
            let token = window.localStorage.getItem('userToken')
            getModelByIdNoView(id, token).then(res=>{
                if(res.code === 200){
                    this.ruleForm.id = res.data.id
                    this.ruleForm.updatedAt = res.data.updatedAt
                    this.ruleForm.name = res.data.name
                    this.ruleForm.isPublic = res.data.isPublic
                    this.ruleForm.modelLong = res.data.modelLong
                    this.ruleForm.modelWide = res.data.modelWide
                    this.ruleForm.modelHeight = res.data.modelHeight
                    this.ruleForm.size = res.data.size
                    this.ruleForm.isPublic = res.data.isPublic
                    this.ruleForm.tag = res.data.tags
                    this.ruleForm.text = res.data.remark ? res.data.remark : ''
                    this.ruleForm.fileUrl = res.data.modelUrl
                    this.ruleForm.file = [{name: res.data.modelUrl.split('-').pop(), url: res.data.modelUrl}]
                    this.ruleForm.modelHash = res.data.modelHash
                    this.ruleForm.colorUrl = res.data.colorMap
                    this.ruleForm.colorMapHash = res.data.colorMapHash
                    this.ruleForm.color = res.data.colorMap ? [{name: res.data.colorMap.split('-').pop(), url: res.data.colorMap}] : []
                    this.ruleForm.thumbnailUrl = res.data.thumbnail
                    this.ruleForm.thumbnail = [{name: res.data.thumbnail.split('-').pop(), url: res.data.thumbnail}]
                    this.ruleForm.thumbnailHash = res.data.thumbnailHash
                    this.ruleForm.aoUrl = res.data.aoMap ? res.data.aoMap : ''
                    this.ruleForm.ao = res.data.aoMap ? [{name: res.data.aoMap.split('-').pop(), url: res.data.aoMap}] : []
                    this.ruleForm.aoMapHash = res.data.aoMapHash ? res.data.aoMapHash : ''
                    this.ruleForm.normalUrl = res.data.normalMap ? res.data.normalMap : ''
                    this.ruleForm.normal = res.data.normalMap ? [{name: res.data.normalMap.split('-').pop(), url: res.data.normalMap}] : []
                    this.ruleForm.normalMapHash = res.data.normalMapHash ? res.data.normalMapHash : ''
                    this.ruleForm.mentalUrl = res.data.metallicMap ? res.data.metallicMap : ''
                    this.ruleForm.mental = res.data.metallicMap ? [{name: res.data.metallicMap.split('-').pop(), url: res.data.metallicMap}] : []
                    this.ruleForm.metallicMapHash = res.data.metallicMapHash ? res.data.metallicMapHash : ''
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        getAllTags(){
            let token = window.localStorage.getItem('userToken')
            getAllTag({}, token).then(res=>{
                if(res.code === 200){
                    this.categories = res.data
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        getModelAction(){
            return baseUrl + '/upload/model'
        },
        getAction(){
            return baseUrl + '/upload/image'
        },
        handleExceedFile(){
            this.$message.error('只能上传一个文件，请删除后重新上传')
        },
        handleBeforeUpload(file) {
            const fileData = new FormData()
            fileData.append('file', file)
            const token = window.localStorage.getItem('userToken')
            fileUpload(token,fileData).then(res=>{
                console.log('上传成功',res.data[0])
            })
        },
        submitForm(formName) {
            let obj = {
                id: this.ruleForm.id,
                updatedAt: this.ruleForm.updatedAt,
                isPublic: this.ruleForm.isPublic,
                name: this.ruleForm.name,
                modelUrl: this.ruleForm.fileUrl,
                modelHash: this.ruleForm.modelHash,
                thumbnail: this.ruleForm.thumbnailUrl,
                thumbnailHash: this.ruleForm.thumbnailHash,
                modelLong: this.ruleForm.modelLong,
                modelWide: this.ruleForm.modelWide,
                modelHeight: this.ruleForm.modelHeight,
            }
            if(this.ruleForm.aoUrl) obj.aoMap = this.ruleForm.aoUrl
            if(this.ruleForm.aoMapHash) obj.aoMapHash = this.ruleForm.aoMapHash
            if(this.ruleForm.mentalUrl) obj.metallicMap = this.ruleForm.mentalUrl
            if(this.ruleForm.metallicMapHash) obj.metallicMapHash = this.ruleForm.metallicMapHash
            if(this.ruleForm.colorUrl) obj.colorMap = this.ruleForm.colorUrl
            if(this.ruleForm.colorMapHash) obj.colorMapHash = this.ruleForm.colorMapHash
            if(this.ruleForm.normalUrl) obj.normalMap = this.ruleForm.normalUrl
            if(this.ruleForm.normalMapHash) obj.normalMapHash = this.ruleForm.normalMapHash
            if(this.ruleForm.text) obj.remark = this.ruleForm.text
            if(this.ruleForm.tag) obj.tags = this.ruleForm.tag
            let token = window.localStorage.getItem('userToken')
            console.log("上传的对象", obj);
            editUserModel(token, obj).then(res=>{
                if(res.code === 200){
                    this.$message.success('编辑成功');
                    // 清空
                    this.$refs['ruleForm'].resetFields();
                    for(let i = 1; i < 6; i++){
                        this.$refs[`upload${i}`].clearFiles()
                    }
                    this.$refs.upload.clearFiles();
                    this.fileListInfo.ao = []
                    this.fileListInfo.color = []
                    this.fileListInfo.normal = []
                    this.fileListInfo.mentallicity = []
                    this.fileListInfo.modelFile = []
                    this.fileListInfo.thumbnail = []
                    // 清空所有的hash
                    this.ruleForm.modelHash = ''
                    this.ruleForm.thumbnailHash = ''
                    this.ruleForm.aoMapHash = ''
                    this.ruleForm.metallicMapHash = ''
                    this.ruleForm.colorMapHash = ''
                    this.ruleForm.normalMapHash = ''
                    // 跳转
                    this.$router.push('/user/user_model')
                } else {
                    this.$message.error('上传失败', res.message);
                }
            })
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(valid);
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        upLoadImage(response, file, fileList) {
            // const fileData = new FormData()
            // fileData.append('file', file.raw)
            // const token = window.localStorage.getItem('userToken')
            // fileUpload(token,fileData).then(res=>{
                console.log(response);
                console.log(file)
            // })
        },
        handleUploadError(err, file, fileList) {
            // 上传失败后的回调函数
            console.log(err);
        },
        // 上传modelFile
        handleChangeFile(response, file, fileList){
            // console.log('file:', file);
            // console.log('response', response.response);
            // console.log(URL.createObjectURL(file.raw));
            // 限制大小
            if(file.size > 1024*1024*10){
                this.$message.error('文件大小不能超过10M，清重新上传')
                return
            }
			// // 本地电脑路径
            // console.log(index);
			// console.log(document.getElementsByClassName("el-upload__input")[index].value);
            // 显示本地路径
            if(!this.fileListInfo.modelFile.localPath){
                this.fileListInfo.modelFile.localPath = document.getElementsByClassName("el-upload__input")[0].value
            }
        },
        // modelFile上传成功后的回调函数
        handleSuccessFile(response, file){
            console.log(file);
            this.fileListInfo.modelFile.name = file.name
            this.fileListInfo.modelFile.state = true
            // this.fileListInfo.modelFile.path = response.data[0]
            this.ruleForm.file.name = file.name
            this.ruleForm.fileFormat = file.name.slice(file.name.lastIndexOf('.')+1)
            this.ruleForm.fileUrl = response.data.fileUrl
            this.ruleForm.modelHash = response.data.fileHash
            this.ruleForm.size = file.size/1024/1024
        },
        // 上传modelFile失败
        handleErrorFile(){

        },
        // 上传color
        handleChangeColor(){
            if(!this.fileListInfo.color.localPath){
                this.fileListInfo.color.localPath = document.getElementsByClassName("el-upload__input")[1].value
            }
        },
        // color上传成功后的回调函数
        handleSuccessColor(response, file){
            this.fileListInfo.color.name = file.name
            this.fileListInfo.color.state = true
            // this.fileListInfo.color.path = response.data[0]
            this.ruleForm.color.name = file.name
            this.ruleForm.colorUrl = response.data.fileUrl
            this.ruleForm.colorMapHash = response.data.fileHash
        },
        // 上传mental
        handleChangeMental(){
            if(!this.fileListInfo.mentallicity.localPath){
                this.fileListInfo.mentallicity.localPath = document.getElementsByClassName("el-upload__input")[2].value
            }
        },
        // mental上传成功后的回调函数
        handleSuccessMental(response, file){
            console.log(URL.createObjectURL(file.raw));
            this.fileListInfo.mentallicity.name = file.name
            this.fileListInfo.mentallicity.state = true
            // this.fileListInfo.mentallicity.path = response.data[0]
            this.ruleForm.mental.name = file.name
            this.ruleForm.mentalUrl = response.data.fileUrl
            this.ruleForm.metallicMapHash = response.data.fileHash
        },
        // 上传ao
        handleChangeAo(){
            if(!this.fileListInfo.chartlet.localPath){
                this.fileListInfo.chartlet.localPath = document.getElementsByClassName("el-upload__input")[3].value
            }
        },
        // ao上传成功后的回调函数
        handleSuccessAo(response, file){
            this.fileListInfo.chartlet.name = file.name
            this.fileListInfo.chartlet.state = true
            // this.fileListInfo.chartlet.path = response.data[0]
            this.ruleForm.aoUrl = response.data.fileUrl
            this.ruleForm.ao.name = file.name
            this.ruleForm.aoMapHash = response.data.fileHash
        },
        // 上传normal
        handleChangeNormal(){
            if(!this.fileListInfo.normal.localPath){
                this.fileListInfo.normal.localPath = document.getElementsByClassName("el-upload__input")[4].value
            }
        },
        // normal上传成功后的回调函数
        handleSuccessNormal(response, file){
            this.fileListInfo.normal.name = file.name
            this.fileListInfo.normal.state = true
            // this.fileListInfo.normal.path = response.data[0]
            this.ruleForm.normalUrl = response.data.fileUrl
            this.ruleForm.normal.name = file.name
            this.ruleForm.normalMapHash = response.data.fileHash
        },
        // 上传shrink
        handleChangeShrink(file, fileList){
            // console.log(file);
            // let fileName = file.name
            if(!this.fileListInfo.thumbnail.localPath){
                this.fileListInfo.thumbnail.localPath = document.getElementsByClassName("el-upload__input")[5].value
            }
        },
        // shrink上传成功后的回调函数
        handleSuccessShrink(response, file){
            console.log(file);
            this.fileListInfo.thumbnail.name = file.name
            this.fileListInfo.thumbnail.state = true
            // this.fileListInfo.thumbnail.path = response.data[0]
            this.ruleForm.thumbnailUrl = response.data.fileUrl
            this.ruleForm.thumbnail.name = file.name
            this.ruleForm.thumbnailHash = response.data.fileHash
            // this.ruleForm.shrink.name = file.name
            // this.ruleForm.shrinkUrl = response.data.fileUrl
            // this.ruleForm.shrinkMapHash = response.data.fileHash
            // this.ruleForm.shrinkFormat = file.raw.type
            // this.ruleForm.shrinkSize = file.raw.size/1024/1024,
            // this.ruleForm.shrinkName = file.raw.name
        },
        upLoadFile(){
            
        }
    }
}
</script>

<style scoped lang="less">
.finishBtn{
    background-color: green !important;
    color: #fff !important;
}
.finishBtn:hover{
    background-color: green !important;
    color: #fff !important;
}
::v-deep .el-textarea{
    width: 30rem;
}
::v-deep .el-input__inner{
    height: 36px;
    // background-color: rgb(226, 241, 254);
    // border-radius: 15px;
}
::v-deep .el-form-item__label{
    padding: 0 0 0 0;
    text-align: left;
    color: #999999;
    font-size: 0.97rem;
    // margin-right: 1rem;
}
::v-deep .el-form-item{
    width: 33.3%;
}
::v-deep .el-button{
    height: 20px;
    width: 120px;
    font-size: 12px;
    line-height: 0px;
    background-color: #54d1ef;
    border-radius: 12px;
    color: #fff;
}
::v-deep .el-form-item__error{
    padding-left: 1rem;
}

::v-deep .el-form-item__content{
    margin-left: 110px !important;
}
.upload{
    padding: 3.5rem 5rem;
    .name{
        width: 200px;
        // background-color: red;
    }
    .model_scale{
        display: flex;
        flex-wrap: wrap;
        ::v-deep .el-input__inner{
            width: 150px;
            margin-right: 3rem;
            // text-align: center;
            // background-color: rosybrown;
        }
    }
    .model_tag{
        ::v-deep .el-input__inner{
            width: 30rem;
        }
    }
    .model_file, .model_color, .model_ao, .model_mental, .model_normal, .model_shrink{
        display: flex;
        .pathAndName{
            display: flex;
            width: 25rem;
            // background-color: #54d1ef;
            margin-left: 5rem;
            span{
                width: 50%;
                font-size: 0.8rem;
                color: #a5a6a6;
                line-height: 40px;
            }
        }
    }
    .uploadBtn{
        // background-color: aqua;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .uploadBtn_submit{
            ::v-deep .el-button{
                color: #fff;
            }
        }
        .uploadBtn_cancel{
            ::v-deep .el-button{
                color: #666666;
                background-color: #E6EEF4;
            }
        }
        ::v-deep .el-button{
            width: 3.25rem;
            height: 3.25rem;
            border-radius: 90%;
            font-size: 0.97rem;
            letter-spacing: 2px;
            padding: 0;
            margin-bottom: 1rem;
        }
    }
}
</style>